/* eslint-disable max-len */
import get from 'lodash/get'
import { fromPythonTS } from 'utils/time'
import { QUEST_RULES, QUEST_SQUAD, QUEST_STATUSES, TANK_STATUSES } from './components/clan_quests_constants'
import { VEHICLE_TYPES } from 'constants'

function getQuestsList(data) {
    const questsList = []

    if (data.quest_info && data.quest_info.length === 0) return questsList

    for (let i = 0; i <= 2; i++) {
        let keyName
        const { rule } = data.quest_info[i].conditions.main
        Object.keys(rule)
            .filter(key => key !== 'type')
            .forEach(key => {
                keyName = key
            })

        questsList.push({
            level: get(data, `quest_info.${i}.level`, 1),
            name: get(data, `quest_info.${i}.name`, ''),
            currentProgress: get(data, `quest_info.${i}.current_progress`, 0),
            requiredProgress: get(data, `quest_info.${i}.required_progress`, 0),
            status: get(data, `quest_info.${i}.status`, QUEST_STATUSES.INCOMPLETE),
            rewards: {
                tourCoin: get(data, `quest_info.${i}.rewards.tourcoin`, 0),
                industrialResource: get(data, `quest_info.${i}.rewards.industrial_resource`, 0),
            },
            conditions: {
                main: {
                    rule: {
                        type: get(data, `quest_info.${i}.conditions.main.rule.type`, QUEST_RULES.FULL_DAMAGE),
                        value: get(data, `quest_info.${i}.conditions.main.rule.${keyName}`, 0),
                    },
                    squadStates: get(data, `quest_info.${i}.conditions.main.squad_states`, [QUEST_SQUAD.SOLO]),
                    isClanSquad: get(data, `quest_info.${i}.conditions.main.is_clan_squad`, false),
                },
                alternative: {
                    rule: {
                        type: get(data, `quest_info.${i}.conditions.alternative.rule.type`, QUEST_RULES.WIN),
                    },
                    squadStates: get(data, `quest_info.${i}.conditions.alternative.rule.squad_states`, [QUEST_SQUAD.SOLO]),
                    isClanSquad: get(data, `quest_info.${i}.conditions.alternative.is_clan_squad`, false),
                },
                common: {
                    levelFrom: get(data, `quest_info.${i}.conditions.common.level_from`, 0),
                    levelTo: get(data, `quest_info.${i}.conditions.common.level_to`, 0),
                },
            },
        })
    }

    return questsList
}

export function questsDataModel(data) {
    const questsList = getQuestsList(data)
    const enabled = questsList.length === 0 ? false : get(data, 'enabled', false)

    return {
        enabled: enabled,
        cycleDuration: get(data, 'cycle_duration', 0),
        cycleEnd: fromPythonTS(get(data, 'cycle_end', 0)),
        previousRewards: {
            tourCoin: get(data, 'previous_rewards.tourcoin', 0),
            industrialResource: get(data, 'previous_rewards.industrial_resource', 0),
        },
        questsList,
    }
}

export function mapSettingsDataModel(data) {
    return {
        enabled: get(data, 'enabled', false),
        regionsCount: get(data, 'regions_count', 0),
        prize: {
            availableImage: get(data, 'prize.available_image', ''),
            notAvailableImage: get(data, 'prize.not_available_image', ''),
            type: get(data, 'prize.type', VEHICLE_TYPES[0]),
            level: get(data, 'prize.level', 1),
            title: get(data, 'prize.title', ''),
        },
    }
}

export function mapProgressDataModel(data) {
    return {
        regionsUnlocked: get(data, 'regions_unlocked', 0),
        finalRegion: {
            status: get(data, 'final_region.status', TANK_STATUSES.UNAVAILABLE),
            price: get(data, 'final_region.price', 0),
        },
        cheapestRegionPrice: get(data, 'cheapest_region', 0),
    }
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/models.js